module.exports = __webpack_public_path__ + "static/media/emojis_16.718fa671.svg";